import WelcomeFeatures from "./WelcomeFeatures";
import useNavbar from "./useNavbar";
import TutorialScene from "./TutorialScene";

export default function LearningCenter(){

  const [ selected, navbar ] = useNavbar({
    options:[
      {_id:"tutorials",label:"Tutorials"},
      {_id:"docs",label:"Documentation"}
    ],
  },"tutorials")

  let tutorialOptions = [
    {_id:"blot-gel",label:"Blot/gel figure creation"},
    {_id:"microscop",label:"Microscopy figure creation"}
  ]

  let tutorials = (
    <div class="fair-padding">
      {tutorialOptions.map(opt =>  {
        return (
          <div class="clickable-text">{opt.label}</div>
        )
      })}
    </div>
  )

  return (
    <div class="full-dim">
      {navbar}
      <div class="thin-horizontal-line"/>
      {selected==="tutorials" && <TutorialScene/>}
      {selected === "docs" && <WelcomeFeatures/>}
    </div>
  )


}
